import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {TpiGroupDetailDto} from "./api/dtos";

import TpiGroupChart from "./tpi-group-chart";

function AutomatedTpiGroupDetailResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<TpiGroupDetailDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: TpiGroupDetailDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <TpiGroupChart tpi={response}/>
            </div>
        )
    }
}


export default AutomatedTpiGroupDetailResult;
